// hooks/useCreateNewReservation.ts
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { RootState } from "../store"; // Adjust the import based on your file structure
import { InitializeStripePaymentData } from "../../api/types";
import Logger from "../helpers/logger";
import ErrorTracker from "../helpers/errorTracker";
import { stripePaymentInitialized } from "../slice/bookingCreation/bookingCreationSlice";
import { notifyActionableBookingFailure } from "../helpers/failureNotification";
import { buildAppUrl } from "../../util";

import { useInitializeStripePaymentMutation } from "../../api/payments/paymentsApiSlice";
import { bookingRecipient } from "../../util/bookingRecipient";

export const useInitializeStripePayment = ({
  service,
}: {
  service: string;
}) => {
  const reservationIds = useSelector((state: RootState) =>
    state.bookingCreation.reservations.map(
      (reservation: any) => reservation.reservationId
    )
  );

  const reservationSnippetIds = useSelector((state: RootState) =>
    state.bookingCreation.reservationsSnippets?.map(
      (reservation: any) => reservation.reservationId
    )
  );

  const order = useSelector(
    (state: RootState) => state.booking.selectedBooking
  );

  const personalContact = useSelector(
    (state: RootState) => state.bookingCreation.personalData
  );
  const hostContact = useSelector(
    (state: RootState) => state.bookingCreation.landlordData
  );

  const recipientSource = useSelector(
    (state: RootState) => ({
      isForSomeoneElse: state.bookingCreation.isForSomeoneElse,
      someoneElseData: state.bookingCreation.someoneElseData,
      recipientData: state.bookingCreation.recipientData,
    }),
    shallowEqual
  );

  const [initializeStripePaymentMutation] =
    useInitializeStripePaymentMutation();

  const dispatch = useDispatch();

  const initializeStripePayment = async () => {
    try {
  if ((reservationIds.length && (personalContact || hostContact)) || (reservationSnippetIds?.length)) {
        let returnUrl = buildAppUrl(
          `/payments/stripe/return?reservationIds=${reservationIds.join(",")}`
        );

        const recipientData = bookingRecipient(recipientSource);

  let payload: InitializeStripePaymentData;
  // For keys service, use host details as the contact; otherwise use personal details
  const contact = service === "keys" ? hostContact : personalContact;
        
        if (service === "parcel") {
          if (order) {
            returnUrl = buildAppUrl(`/orders/${order.id}`);
          }
          const contact = {
            firstName: 'test',
            lastName: 'test',
            phone: '+49111111111',
            email: 'dev@kolula.com',
            newsletterConsent: false,
            isAgreed: true,
          }
          payload = {
            reservationIds: reservationSnippetIds,
            contact: contact,
            returnUrl,
            cancelUrl: buildAppUrl("/payments/stripe/return?cancelled=true"),
            service,
              }
        } else {
          payload = {
            reservationIds: reservationIds,
            contact: contact,
            recipient: recipientData,
            returnUrl,
            cancelUrl: buildAppUrl("/payments/stripe/return?cancelled=true"),
            service,
              };
        }

        const response = await initializeStripePaymentMutation(
          payload
        ).unwrap();

        if (response) {
          dispatch(stripePaymentInitialized(response));
        }

        return response;
      }
    } catch (error) {
      Logger.for("createNewReservation").error(error);
      ErrorTracker.trackException(error as Error);
      // The payment step already renders a persistent failure panel; add the
      // reason only when it is one the customer can act on (#1970).
      notifyActionableBookingFailure(dispatch, error);
    }
  };

  return initializeStripePayment;
};
